module.exports = __webpack_public_path__ + "img/updata-userData_logo.390d14e0.svg";